import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clients } from '../clients';
import { QueryKey } from '../hooks/QueryKey';

export function useTagReviewMutation(teamId: number) {
  const queryClient = useQueryClient();
  const {
    mutateAsync: tagReview,
    isLoading: isTaggingReview,
    error: tagReviewError,
  } = useMutation({
    mutationFn: async (data: { tags: number[]; reviewId: number }) => {
      return await clients.team.tagReview({
        args: { teamId, reviewId: data.reviewId },
        payload: data,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries([QueryKey.Team, teamId, 'reviews']);
    },
  });

  return {
    tagReview,
    isTaggingReview,
    tagReviewError,
  };
}
